import BaseClient from "../baseClient";
import SubmitRequestBody from "./submitRequest";

export default class EnquiryClient extends BaseClient {

    public async submitAsync(request: SubmitRequestBody) : Promise<void> {

        request.recaptchaToken = await super.recaptchaChallengeAsync('enquiry_form_submit');

        await super.makeRequestAsync({
            controller: 'enquiry',
            action: 'submit',
            method: 'post', 
            body: request });
    }
}